import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import NativeSelect from '@mui/material/NativeSelect';
import { AllHWTopic } from '../../../../../constants/hw';
import { validateRequiredSelect } from '../validate';

const renderHWTopicField = ({ input, meta: { touched, error }, i18n, ...custom }) => {
    const showError = touched && error;
    return (
        <div
            style={{
                borderBottom: showError ? '2px solid red' : '2px solid transparent',
                paddingBottom: 4,
            }}
        >
            <NativeSelect {...input} {...custom}>
                <option value="">{i18n.t('hwTemplateSettings.selectTopic')}</option>
                {AllHWTopic.map((item, key) => (
                    <option key={key} value={item.label.replace(/\s/g, '')}>
                        {item.label}
                    </option>
                ))}
            </NativeSelect>
        </div>
    );
};

export default ({ label, code }) => {
    const { i18n } = useTranslation();

    return (
        <Card>
            <CardContent>
                <Typography gutterBottom variant="h6" component="h2">
                    {i18n.t(label)}
                </Typography>
                <Field
                    name={code}
                    component={renderHWTopicField}
                    type="text"
                    i18n={i18n}
                    validate={validateRequiredSelect}
                />
            </CardContent>
        </Card>
    );
};
